/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsPress = {
  init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsPress = $.extend(this, Shopify.theme.getSectionData($section));

    if(this.press_style == 'slider') {
      
      this.createSlider();
    }   
 $(document).ready(function(){
    
    let pressSlider = $('.press .press-list__item');
    let maxHeight = 0;
    $(pressSlider).css('min-height', 0);
    
    setTimeout(function(){
      $(pressSlider).each(function(){
        if ($(this).outerHeight() > maxHeight) { maxHeight = $(this).outerHeight(); }              
      });
      $(pressSlider).css('min-height', maxHeight);
    },1000);
  });
  
  $(window).resize(function(){
    let pressSlider = $('.press .press-list__item');
    let maxHeight = 0;
    $(pressSlider).css('min-height', 0);
    
    setTimeout(function(){
      $(pressSlider).each(function(){
        if ($(this).outerHeight() > maxHeight) { maxHeight = $(this).outerHeight(); }              
      });
      $(pressSlider).css('min-height', maxHeight);
    },1000);
  });
  

  },
  createSlider: function() {

    let pressSlider = $('.press.layout--slider .slider-gallery');
    let maxHeight = 0;

    const slideData = {
      slides_per_slide: this.slides_per,
      slides_available: this.slides_available,
      slides_limit: this.slides_limit,      
      cellAlign: "left",
      wrapAround: true
    }

    $(pressSlider).flickity({
      lazyLoad: 2,
      freeScroll: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: slideData.wrapAround,
      pageDots: true,
      contain: true,
      prevNextButtons: slideData.slides_limit > slideData.slides_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(pressSlider).on( 'settle.flickity', function() {
            $(pressSlider).flickity('resize');            
          });
        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;